import { Navigate, useLocation } from "react-router-dom";
import { hasCapability, homeFor, routeForAuth, useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/components/common/FullScreenLoader";

export function RequireAuth({ children, area, capability }) {
  const auth = useAuth();
  const location = useLocation();
  if (auth.status === "loading") return <FullScreenLoader />;
  if (auth.status === "anonymous") return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  if (auth.session.state !== "active") return <Navigate to={routeForAuth({ status: auth.session.state, user: auth.user })} replace />;
  if (area && homeFor(auth.user) !== area) return <Navigate to={homeFor(auth.user)} replace />;
  if (capability && !hasCapability(auth.user, capability)) return <Navigate to={homeFor(auth.user)} replace />;
  return children;
}

export function RequireSessionState({ children, state }) {
  const auth = useAuth();
  if (auth.status === "loading") return <FullScreenLoader />;
  if (auth.status === "anonymous") return <Navigate to="/sign-in" replace />;
  if (auth.session.state !== state) return <Navigate to={routeForAuth({ status: auth.session.state, user: auth.user })} replace />;
  return children;
}

export function RequireEnrolable({ children }) {
  const auth = useAuth();
  if (auth.status === "loading") return <FullScreenLoader />;
  if (auth.status === "anonymous") return <Navigate to="/sign-in" replace />;
  if (auth.session.state === "mfa_required") return <Navigate to="/mfa" replace />;
  if (auth.user.mfa_enabled) return <Navigate to={homeFor(auth.user)} replace />;
  return children;
}

export function PublicOnly({ children }) {
  const auth = useAuth();
  if (auth.status === "loading") return <FullScreenLoader />;
  if (auth.status === "authenticated") return <Navigate to={routeForAuth({ status: auth.session.state, user: auth.user })} replace />;
  return children;
}
